import { create } from '@bufbuild/protobuf'
import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { SaveApprovalFlowRequestSchema } from '@ebalance/proto/bffuser/v1/approval_flow_service_pb'

import { convertProcessStateToRequest } from '~/pages/AdminApprovalFlow/models/converter'
import type {
  MatrixAction,
  ProcessState,
} from '~/pages/AdminApprovalFlow/models/reducer'

type SaveAsyncFn = (
  req: ReturnType<typeof create<typeof SaveApprovalFlowRequestSchema>>,
) => Promise<{ updatedAt?: Timestamp | undefined }>

/**
 * 1 プロセスを保存し、MARK_SAVED を dispatch する。
 *
 * ProcessAccordion (per-プロセス保存) と index.tsx (dirty-all 保存) の
 * 共通 core を集約する。toaster 等の UI feedback は caller 側で行う。
 */
export async function saveProcess(
  proc: ProcessState,
  saveAsync: SaveAsyncFn,
  dispatch: (action: MatrixAction) => void,
): Promise<void> {
  const cells = convertProcessStateToRequest(proc)
  const res = await saveAsync(
    create(SaveApprovalFlowRequestSchema, {
      businessProcess: proc.businessProcess,
      cells,
      // proto に残る切替条件は使わない (承認フローは入札 2 業務処理のみ)
      conditions: [],
      expectedUpdatedAt: proc.updatedAt,
    }),
  )
  dispatch({
    type: 'MARK_SAVED',
    businessProcess: proc.businessProcess,
    updatedAt: res.updatedAt,
  })
}
